<template>
  <div :style="videoWrapStyles">
    <video id="my-player" ref="videoRef" class="video-js w-full h-full" :poster="poster">
      <source :src="src" />
    </video>
  </div>
</template>

<script setup>
  import { computed, onMounted, ref } from 'vue'
  import videojs from 'video.js'
  import 'video.js/dist/video-js.min.css'
  const props = defineProps({
    src: String,
    poster: String,
    width: String,
    height: String
  })
  // video标签
  const videoRef = ref(null)
  // video实例对象
  let videoPlayer = null
  const videoWrapStyles = computed(() => {
    return {
      width: props.width || '100%',
      height: props.height || '100%'
    }
  })
  // 初始化videojs
  const initVideo = () => {
    // https://gitcode.gitcode.host/docs-cn/video.js-docs-cn/docs/guides/options.html
    const options = {
      language: 'zh-CN', // 设置语言
      controls: true, // 是否显示控制条
      preload: 'auto', // 预加载
      autoplay: true, // 是否自动播放
      fluid: false, // 自适应宽高
      src: props.src // 要嵌入的视频源的源 URL
    }
    if (videoRef.value) {
      // 创建 video 实例
      videoPlayer = videojs(videoRef.value, options, onPlayerReady)
    }
  }
  // video初始化完成的回调函数
  const onPlayerReady = () => {}
  onMounted(() => {
    initVideo()

    document.title = '操作说明';
  })
</script>

<style lang="less" scoped>
  .w-full {
    width: 100%;
  }
  .h-full {
    height: 100%;
  }
  .video-js{
    &:deep(.vjs-poster){  
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: 50% 50%;
      }
    }
  }
</style>